export const ACTION_CODE = 'MISSION' + '_ACTION';
